var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 40 24",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa",
    gradientUnits: "objectBoundingBox",
    x1: 0.5,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -79.451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 101.394a2.227 2.227 0 0 1 -2.364 2.057h-35.272a2.227 2.227 0 0 1 -2.364-2.057v-19.886a2.227 2.227 0 0 1 2.364-2.057h35.272a2.227 2.227 0 0 1 2.364 2.057z",
    fill: "url(#visa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.681 101.394v-19.886a2.227 2.227 0 0 1 2.365-2.057h-1.682a2.227 2.227 0 0 0 -2.364 2.057v19.886a2.227 2.227 0 0 0 2.364 2.057h1.682a2.227 2.227 0 0 1 -2.365-2.057z",
    fill: "#202121",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.8 188.216 1.389-7.816h2.171l-1.346 7.816z",
    fill: "#3c58bf",
    transform: "translate(-168.458 -92.916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.8 188.216 1.78-7.816h1.78l-1.346 7.816z",
    fill: "#293688",
    transform: "translate(-168.458 -92.916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.643 175.947a5.507 5.507 0 0 0 -2-.347c-2.171 0-3.734 1.086-3.734 2.649 0 1.172 1.085 1.78 1.954 2.171s1.129.651 1.129 1c0 .521-.695.782-1.3.782a4.719 4.719 0 0 1 -2.084-.434l-.3-.13-.3 1.78a7.04 7.04 0 0 0 2.475.434c2.3 0 3.821-1.086 3.821-2.735 0-.912-.564-1.607-1.867-2.171-.782-.391-1.259-.608-1.259-1 0-.347.391-.695 1.259-.695a3.983 3.983 0 0 1 1.65.3l.217.087.347-1.693z",
    fill: "#3c58bf",
    transform: "translate(-228.228 -88.377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.643 175.947a5.507 5.507 0 0 0 -2-.347c-2.171 0-3.343 1.086-3.343 2.649a2.27 2.27 0 0 0 1.563 2.171c.868.391 1.129.651 1.129 1 0 .521-.695.782-1.3.782a4.719 4.719 0 0 1 -2.084-.434l-.3-.13-.3 1.78a7.04 7.04 0 0 0 2.475.434c2.3 0 3.821-1.086 3.821-2.735 0-.912-.564-1.607-1.867-2.171-.782-.391-1.259-.608-1.259-1 0-.347.391-.695 1.259-.695a3.983 3.983 0 0 1 1.65.3l.217.087.347-1.693z",
    fill: "#293688",
    transform: "translate(-228.228 -88.377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.785 180.4c-.521 0-.912.043-1.129.564l-3.256 7.251h2.345l.434-1.3h2.779l.26 1.3h2.082l-1.824-7.816zm-1 5.21c.13-.391.868-2.3.868-2.3s.174-.478.3-.782l.13.738s.434 1.954.521 2.388h-1.824z",
    fill: "#3c58bf",
    transform: "translate(-332.636 -92.916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.306 180.4c-.521 0-.912.043-1.129.564l-3.778 7.251h2.345l.434-1.3h2.779l.26 1.3h2.083l-1.824-7.816zm-1.52 5.21c.174-.434.868-2.3.868-2.3s.174-.478.3-.782l.13.738s.434 1.954.521 2.388h-1.824z",
    fill: "#293688",
    transform: "translate(-332.636 -92.916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.456 186.627-.217-1.129a6.294 6.294 0 0 0 -3.039-3.43l1.954 6.947h2.346l3.517-7.816h-2.346z",
    fill: "#3c58bf",
    transform: "translate(-42.109 -93.673)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.456 186.627-.217-1.129a6.294 6.294 0 0 0 -3.039-3.43l1.954 6.947h2.346l3.517-7.816h-1.91z",
    fill: "#293688",
    transform: "translate(-42.109 -93.673)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 180.4.391.087a7.323 7.323 0 0 1 5.427 4.255l-.782-3.691c-.13-.521-.521-.651-1-.651z",
    fill: "#ffbc00",
    transform: "translate(6.312 -92.916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 180.4c2.779.651 5.08 2.345 5.818 4.3l-.738-3.083a1.06 1.06 0 0 0 -1.042-.825z",
    fill: "#f7981d",
    transform: "translate(6.312 -92.916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 180.4c2.779.651 5.08 2.345 5.818 4.3l-.518-1.695a1.531 1.531 0 0 0 -.912-1.259z",
    fill: "#ed7c00",
    transform: "translate(6.312 -92.916)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#051244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.384 200.742-1.476-1.476-.695 1.65-.174-1.085a6.294 6.294 0 0 0 -3.039-3.431l1.954 6.947h2.346z",
    transform: "translate(-42.866 -108.048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.014 291.11-1.867-1.91-.347 1.91z",
    transform: "translate(-168.458 -195.811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.778 274.8c.174.174.261.3.217.478 0 .521-.695.782-1.3.782a4.72 4.72 0 0 1 -2.084-.434l-.3-.13-.3 1.78a7.04 7.04 0 0 0 2.475.434 4.3 4.3 0 0 0 3.17-1.086z",
    transform: "translate(-228.228 -182.193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364 225.288h2.041l.434-1.3h2.779l.26 1.3h2.086l-.738-3.17-2.605-2.518.13.695s.434 1.954.521 2.388h-1.824c.174-.434.868-2.3.868-2.3s.174-.478.3-.782",
    transform: "translate(-337.932 -129.989)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.82ddd1ead357ef5b509fb2cb86a95036.svg";
export { ForwardRef as ReactComponent };